import { DEFAULT_VIEW_ID } from "features/transactions/TransactionsViewsSidebar/constants";
import { TableViewReadData } from "gen/model/tableViewReadData";

export const isDefaultRow = (view: TableViewReadData) =>
  view.id === DEFAULT_VIEW_ID;

export const isDefaultSelected = (params: { viewId?: string }) =>
  !params.viewId;

export const isSelected = (
  params: { viewId?: string },
  view: TableViewReadData,
) =>
  params.viewId === view.id ||
  (isDefaultSelected(params) && isDefaultRow(view));
